import React from 'react';

import { CrossIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';

// @ts-expect-error не загрузилась декларация
import st from '../OptionsFilter.module.sass';
import type { Option } from '../types';

interface OptionItemProps<T extends Option> {
  option: T;
  name: string;
  checked: boolean;
  onToggle: VoidFunction;
  onRemove?: VoidFunction;
}

export function OptionItem<T extends Option>({
  option,
  name,
  checked,
  onToggle,
  onRemove = undefined,
}: OptionItemProps<T>): React.JSX.Element {
  return (
    <div className={st.OptionItem}>
      <Control.Checkbox
        checked={checked}
        id={`${name}.${String(option.value)}`}
        label={option.label ?? String(option.value)}
        name={name}
        onChange={onToggle}
      />

      {!!onRemove && (
        <Control.IconButton
          data-testid={`deleteOption-${String(option.value)}`}
          icon={<CrossIcon />}
          kind="secondary"
          onClick={onRemove}
          shape="round"
          size="small"
          variant="outlined"
        />
      )}
    </div>
  );
}
